export const PREFIX = "cur8";

export enum URIType {
  Annotation,
  BookingResource,
  FrameSequence,
  PatientBlob,
  PhysicalArtefact,
  PhysicalId,
  Recording,
  RecordingBlob,
  Scan,
  User,
  ImmutableScanBlob,
}
